export { uploadImageFile } from './uploadImageFile';
